import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import Select from "../../ui/Select"

const Container = styled.div`
  display: flex;
  width: 100%;
  ${Select} {
    flex: auto;
    width: 100%;
  }
`
const DropdownFilter = ({
  values = [],
  filter = {},
  setFilter,
  filterByName,
  active,
}) => {
  // Quick simple version to filter based on one status
  const value = filter[filterByName]
  const changed = (e) => {
    const newValue = e.target.value
    filter = {
      ...filter,
      [filterByName]: newValue,
    }
    setFilter(filter)
  }
  return (
    <Container>
      <Select value={value || ""} onChange={changed} active={active}>
        <option value="">Any</option>
        {values.map((s) => (
          <option key={s.name} value={s.value} className={s}>
            {s.name}
          </option>
        ))}
      </Select>
    </Container>
  )
}

DropdownFilter.propTypes = {
  values: PropTypes.array, // {name:"France", value: "FR"} the values to display in the drop down
  filter: PropTypes.object.isRequired,
  setFilter: PropTypes.func.isRequired,
  filterByName: PropTypes.string.isRequired, // The variable name inside filter object to use as the value for the dropdown
  active: PropTypes.bool, // Indication from parent that filter is applied
}

export default DropdownFilter
